<template>
    <component :is="tag" class="smooth-loader" ref="root" :class="showTarget ? 'in' : 'out'">
        <slot></slot>
    </component>
</template>

<script>
import { ref, watch, onMounted, computed } from 'vue';
import { useElementVisibility } from '@vueuse/core'

export default {

    props: {
        delay: {
            type: Number,
            default: 100
        },
        tag: {
            type: String,
            default: 'div'
        },
        trigger: {
            default: null
        }
    },
    
    setup(props) {

        const root = ref(null);

        const target = computed(() => {
            if (props.trigger) {
                return ref(props.trigger);
            } else {
                return root;
            }
        });

        const targetIsVisible = useElementVisibility(target.value);
        const showTarget = ref(false);

        onMounted(async () => {
            if (targetIsVisible.value) {
                await window.wait(props.delay);
                showTarget.value = true;
            }
        });

        watch(targetIsVisible, async (visible) => {
            if (visible) {
                await window.wait(props.delay);
                showTarget.value = true;
            } else {
                showTarget.value = false;
            }
        });

        return {
            root,
            showTarget
        }

    }

}
</script>